import type { DocumentEntity } from 'serviceWorker/repository/document/entity';
import { isSyncStatusAwaitingServer } from 'shared/domain/entitySyncStatus/syncStatus';

/**
 * Whether the server has the document as the user left it: nothing of it
 * waits to be uploaded, deleted, drawn on or retried. Its local data is
 * then a copy of the server's.
 */
export function isDocumentSettled({ syncStatus, drawingSyncStatus }: DocumentEntity): boolean {
  return !isSyncStatusAwaitingServer(syncStatus) && !isSyncStatusAwaitingServer(drawingSyncStatus);
}
